<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <form @submit.prevent="createPrivateChat">
          <v-flex xs12>
            <v-text-field
              name="userId"
              label="User Id"
              id="userId"
              v-model="userId"
              type="text"
              required
            />
            <v-btn type="submit">
              Create
            </v-btn>
          </v-flex>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        userId: ''
      }
    },
    watch: {
      chats (newChats, oldChats) {
        this.$router.push('/chat/' + oldChats.length)
      }
    },
    methods: {
      createPrivateChat () {
        if (this.userId !== '') {
          let key = 0
          this.$store.dispatch('createPrivateChat', { userId: this.userId }).then((value) => {
            const index = this.chats.findIndex(chat => chat.type === 'private' && chat.data.users.includes(userId))
            if (index >= 0) {
              this.$router.push('/chat/' + index)
            }
          })
        }
      }
    },
    computed: {
      chats () {
        return this.$store.getters.chats
      },
    }
  }
</script>
